export default {
  data() {
    return {
      font_families: [],
      custom_fonts: [],
      fonts_loading: false,
    };
  },

  computed: {
    // for use in font dropdown selectors
    organized_font_families() {
      if (this.font_families.length === 0) return [];

      // build organized list with headers - custom fonts first
      const result = [];

      if (this.custom_fonts.length > 0) {
        result.push({ header: 'Custom Fonts' });
        this.custom_fonts.forEach(font => {
          result.push({
            text: font.label || font.text,
            value: font.font_family_name || font.value,
          });
        });
      }

      if (this.font_families.length > 0) {
        result.push({ header: 'Built-in Fonts' });
        this.font_families.forEach(font => {
          result.push({
            text: font.label || font.text,
            value: font.font_family_name || font.value,
          });
        });
      }

      return result;
    },

    /**
     * Maps custom font ids to their display names.
     * Also maps built-in font values to their labels.
     * Provides a single location to access all font names for dropdowns, regardless of custom or built-in.
     */
    font_id_names() {
      const custom = this.custom_fonts.reduce((acc, font) => {
        acc[font.font_family_name] = `${font.label}, ${font.fall_back}`;
        return acc;
      }, {});

      const builtIn = this.font_families.reduce((acc, font) => {
        if (!font.font_family_name) {
          acc[font.value] = font.label || font.text;
        }
        return acc;
      }, {});

      return {
        ...custom,
        ...builtIn,
      };
    },
  },

  methods: {
    /**
     * Loads font families from the server for the given organization.
     * @param {string} organization_id - The ID of the organization to load fonts for.
     * This method fetches available font families and custom fonts, filtering out custom fonts from the
     * built-in font list. It also triggers loading of custom fonts into the browser.
     */
    loadFontFamilies(organization_id) {
      this.fonts_loading = true;
      
      this.$rc.rest({
        spinner: false,
        endpoint: 'LIST: /api/v1/css/available-font-families',
        params: { organization_id },
        on_success: data => {
          const custom_ids = data.custom_fonts.map(({ font_family_name }) => font_family_name);

          this.font_families =
            data.choices?.filter(({ value }) => {
              return !custom_ids.includes(value.split(',')[0]);
            }) || [];

          this.custom_fonts = data.custom_fonts || [];

          this.custom_fonts.forEach((font) => {
            const my_font = new FontFace(
              font.font_family_name, 
              `url('${font.url}')`
            );
            document.fonts.add(my_font);
          });
          
          this.fonts_loading = false;
        },
        on_error: () => {
          this.fonts_loading = false;
          this.$rc.alert('Error', 'Unable to load fonts');
        },
      });
    },

    isCustomFont(font_value) {
      return this.custom_fonts.some(cf => font_value.includes(cf.font_family_name));
    },

    fontSearchFilter(item, query_text) {
      if (!query_text) return true;
      if (item.header) return false; // don't show headers in search results

      const query = query_text.toLowerCase();
      return item.text.toLowerCase().includes(query);
    },
  },
};
